<script setup>
import {onBeforeMount, reactive, ref, watch} from "vue";
import router from "@/router/index.js";
import createTenant from "./components/createTenant/index.vue"
import {ElMessage} from "element-plus";
import {addTenant} from "@/api/user/user.js";

// 加载状态
const loading = ref(false)
// 处理表单提交新建商家
const handleCreateTenant = async () => {
  try {
    loading.value = true
    const res = await addTenant(tenantInfo.value)
    ElMessage.success("创建成功")
    // router.push({ path: "/listTenant" })
    cacheTenantId.value = res
    open.value = true
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

// 创建成功后缓存tenantId
const cacheTenantId = ref()

/*基本信息相关*/
// 商家信息
const tenantInfo = ref({
  // 商家信息
  name: null,
  certificateType: null,
  // 认证类型
  certificationType: "LEGAL_PERSON",
  // 证件信息
  certificateInfo: {
    certificateId: null,
    certificateFrontPhoto: null,
    certificateBackPhoto: null,
  },
  //  进驻类型
  entryType: null,
  // 负责人信息
  contactInfo: {
    contactName: null,
    contactPhone: null,
    contactEmail: null
  },
  // 收款账号信息
  payeeAccountInfo: {
    accountName: null,
    bankAccount: null,
    bankName: null
  },
  // 收件人信息
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  }
})
// 商家信息组件锚点
const createTenantRef = ref()

/*选择合作身份弹窗相关*/
// 弹窗状态
const open = ref(false)
// 处理下一步
const handleNextStep = () => {
  if (checkList.value.length <= 0) return ElMessage.error("请至少选择一个合作身份")
  const target = checkList.value[0]
  if (target === "A") {
    router.push({path: "/addTenantClub", query: {tenantId: cacheTenantId.value}})
  } else if (target === "B") {
    router.push({path: "/addTenantPost", query: {tenantId: cacheTenantId.value}})
  } else if (target === "C") {
    router.push({path: "/addTenantVenue", query: {tenantId: cacheTenantId.value}})
  } else if (target === "D") {
    router.push({path: "/addTenantBikeStore", query: {tenantId: cacheTenantId.value}})
  } else if (target === "E") {
    router.push({path: "/addTenantTherapy", query: {tenantId: cacheTenantId.value}})
  } else if (target === "F") {
    router.push({path: "/addTenantPhotography", query: {tenantId: cacheTenantId.value}})
  } else if (target === "G") {
    router.push({path: "/addTenantBrand", query: {tenantId: cacheTenantId.value}})
  }
}
// 已勾选的合作身份列表
const checkList = ref([])
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createTenant ref="createTenantRef" v-model="tenantInfo" @success="handleCreateTenant"></createTenant>
  </div>
  <el-dialog
      v-model="open"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">新建合作身份</div>
    </template>
    <div>
      <div class="mg_b_2" style="text-align: left;box-sizing: border-box;padding-left: 48px;">
        请选择合作身份类型：
      </div>
      <div style="box-sizing: border-box;padding-left: 48px;">
        <el-checkbox-group v-model="checkList" :max="1">
          <el-checkbox style="display: block;flex: 1;text-align: left" label="俱乐部" value="A" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="驿站" value="B" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="场地" value="C" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="车店" value="D" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="理疗服务商" value="E" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="摄影服务商" value="F" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="品牌方" value="G" />
        </el-checkbox-group>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="handleNextStep">下一步</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>

</style>
